import { ArrowDownLeft, CheckCircle, UserCheck, UserIcon } from 'lucide-react';
import { UserWithRole } from '../../types/mold';
import { UserProfile } from '../../types/user'

interface AssignToMeButtonProps {
    user: UserProfile | null;
    assigneeList: UserWithRole[];
    onChangeAssignee: (newAssignee: UserWithRole) => Promise<void>;
}

const AssignToMeIcon = () => {
    return (
        <div className="relative w-6 h-6">
            {/* Base user icon */}
            <UserIcon className="w-6 h-6 text-blue-500" />

            {/* Arrow pointing to user (top-right corner) */}
            <ArrowDownLeft className="absolute w-3 h-3 text-blue-500 -top-1 -right-1" />
        </div>
    );
};

const AssignToMeButton: React.FC<AssignToMeButtonProps> = ({
    user,
    assigneeList,
    onChangeAssignee,
}) => {
    if (!user) {
        return <></>;
    }
    const assignee = assigneeList.find((assignee) => assignee && assignee.id === user?.user_id)
    if (assignee) {
        return (
            <button
                onClick={() => onChangeAssignee(assignee)}
                className={`shadow-xl w-full py-3 px-4 rounded-md flex items-center justify-center bg-white border-2 border-blue-500 text-blue-500 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
            >
                {/* <UserCheck className="text-blue-500 h-5 w-5 mr-2" /> */}
                <AssignToMeIcon/>
                <span className='ml-2'>มอบหมายให้ฉัน</span>
            </button>
        )
    }
    return <></>;
}
export default AssignToMeButton  